/*
Code for the FAQs Page
*/
import React from "react";
import { Accordion, Button, Col, Row, Container } from "react-bootstrap";
import { Footer } from "./Footer";
import { Header } from "./Header";
import background from "./images/path.jpg";

export const FAQ = () => {
  return (
    <div>
      <Header />
      <div className="page-header">
        <img className="header-img" src={background} alt="background" />
        <h1 className="header-img-caption">FAQs</h1>
        <p className="header-img-text">
          The most frequently asked questions from Data Science students
        </p>
      </div>
      <div className="space1" />
      <Container>
        <Row>
          <Col md={8}>
            <Accordion>
              <Accordion.Item eventKey="0">
                <Accordion.Header className="accordion_header">
                  1. Does this course count for the Data Science minor?
                </Accordion.Header>
                <Accordion.Body className="accordion_text">
                  If it is listed on the official Scripps{" "}
                  <a
                    href="https://catalog.scrippscollege.edu/preview_program.php?catoid=31&poid=4822"
                    target="_blank"
                    rel="noreferrer"
                  >
                    website
                  </a>
                  , or on this{" "}
                  <a
                    href="https://catalog.scrippscollege.edu/preview_program.php?catoid=31&poid=4823"
                    target="_blank"
                    rel="noreferrer"
                  >
                    list
                  </a>
                  , then yes. If not, check with the registrar
                  (registrar@scrippscollege.edu) and your DS advisor.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header className="accordion_header">
                  2. Can I count course X for course Y?
                </Accordion.Header>
                <Accordion.Body className="accordion_text">
                  As a rule of thumb, students are required to take the specific
                  courses listed on the Scripps Website. However, follow the
                  steps above for question 1, and keep in mind that for upper
                  division electives, the faculty do try to tailor those courses
                  to the student's major/academic background.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header className="accordion_header">
                  3. What is data science?
                </Accordion.Header>
                <Accordion.Body className="accordion_text">
                  The study of data to extract meaningful insights. Data
                  scientists utilize a combination of computer science,
                  statistics, and mathematics to provide understanding of data
                  from virtually any field.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3">
                <Accordion.Header className="accordion_header">
                  4. What are the data science courses at Scripps?
                </Accordion.Header>
                <Accordion.Body className="accordion_text">
                  Scripps data science students will take courses in calculus,
                  linear algebra, statistics, computing, philosophy, and coding.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="4">
                <Accordion.Header className="accordion_header">
                  5. What majors go well with data science?
                </Accordion.Header>
                <Accordion.Body className="accordion_text">
                  Majors in the Natural Sciences, Psychology, Math, and
                  Economics offer a variety of upper division courses that are
                  currently listed as data science upper division electives.
                  Note that the data science minor is a minimum of 9 courses if
                  students have not already taken Calc I and II.
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Col>

          <Col md={4} className="d-flex flex-column">
            <h2>Quick Links</h2>
            <Button
              className="linked-button"
              href="https://mycampus.scrippscollege.edu/ics"
            >
              Scripps Student Portal
            </Button>
            <Button
              className="linked-button"
              href="https://catalog.scrippscollege.edu/"
            >
              Scripps Course Catalog
            </Button>
            <Button
              className="linked-button"
              href="https://www.scrippscollege.edu/departments/data-science"
            >
              Scripps Data Science Page
            </Button>
            <Button
              className="linked-button"
              href="https://catalog.scrippscollege.edu/content.php?catoid=33&navoid=4198#Double_Counting_Coursese"
            >
              Double Counting Rules
            </Button>
          </Col>
        </Row>
        <Row>
          <div className="space1" />
          <h2 className="text-center">More Questions?</h2>
          <p className="text-center">
            {" "}
            If you have any more questions, please reach out to a{" "}
            <a href="/faculty" className="faculty-link">
              Data Science Faculty member.
            </a>{" "}
          </p>
        </Row>
      </Container>
      <div className="container1">
        <Footer />
      </div>
    </div>
  );
};
